import { CircularProgress, FlexBox } from '@spazious/react-components';

export type LoadingProps = {};

export const Loading: React.FC<LoadingProps> = () => {
  return (
    <FlexBox
      alignItems="center"
      backgroundColor="rgba(255, 255, 255, 0.5)"
      flex="1"
      inset="0"
      justifyContent="center"
      position="absolute"
      width="100%"
    >
      <CircularProgress />
    </FlexBox>
  );
};

export default Loading;
